<template>
  <div class="news-page">
    <div class="news-details-container">
      <div class="news-details">
        <h1 class="title-big">{{title}}</h1>
        <p class="title-tip">
          <time>{{time}}</time>
          来源：<span>一维大成科技有限公司</span>
        </p>
        <div class="news-content" v-html="content"></div>
        <div class="spacing-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import fetch from '../server/index';

  export default {
    data () {
      return {
        id: '',
        title: '',
        time: '',
        content: ''
      }
    },
    watch: {
      id (n) {
        this.getContentById()
      }
    },
    methods: {
      getContentById () {
        fetch('/api/policyInfo/info',
          {id: this.id}
        ).then(res => {
          this.title = res.title;
          this.time = res.gmtPublish;
          this.content = res.content;
        }, err => {
          console.log(err);
        }).catch(e => {
        })
      }
    },
    mounted () {
      this.id = this.$route.params.id.split(':')[1];
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .news-page {
    $theme-color: #00ccff;
    width: 100%;
    height: 100%;
    background: #f4f4f4;
    .news-details-container {
      @include public_content();
      .news-details {
        width: 960px;
        margin: 0 auto;
        .title-big {
          text-align: center;
          font-size: 18px;
          color: #3b3b3b;
          font-weight: bold;
          padding-top: 40px;
        }
        .title-tip {
          text-align: center;
          padding: 18px 0 20px 0;
          color: #3b3b3b;
          font-size: 14px;
          border-bottom: 1px solid #dcdcdc;
          time {
            padding-right: 20px;
          }
          span, time {
            font-size: 14px;
          }
        }
        .news-content {
          margin-top: 30px;
          min-height: 200px;
          *{
            background: transparent!important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/NewsDetails.vue